module.exports = __webpack_public_path__ + "images/sex-tape-enthusiast-5101281791b7ac6614a44b1d0c7ef89d.png";